import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          <div className="col-span-1 lg:col-span-2">
            <h3 className="text-2xl font-bold text-brand-dark mb-4">
              Central Cleaners <span className="text-gray-400 font-light">&</span> Bennett Valley
            </h3>
            <p className="text-gray-500 max-w-md leading-relaxed mb-6">
              Providing premium dry cleaning, laundry, and alteration services to the Santa Rosa community with a commitment to quality and convenience.
            </p>
            <div className="flex flex-wrap gap-2">
              {['Dry Cleaning', 'Laundry', 'Alterations', 'Pickup & Delivery'].map((tag) => (
                <span key={tag} className="px-3 py-1 bg-surface text-gray-600 text-xs font-medium rounded-full">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Locations</h4>
            <ul className="space-y-4 text-sm text-gray-600">
              <li>
                <strong className="block text-gray-900">Central Cleaners</strong>
                915 4th Street<br/>Santa Rosa, CA 95405
              </li>
              <li>
                <strong className="block text-gray-900">Bennett Valley Dry Cleaners</strong>
                2753 Yulupa Ave<br/>Santa Rosa, CA 95405
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-4">Quick Links</h4>
            <ul className="space-y-3 text-sm text-gray-600">
              <li><a href="#home" className="hover:text-brand transition-colors">Home</a></li>
              <li><a href="#services" className="hover:text-brand transition-colors">Services</a></li>
              <li><a href="#pickup" className="hover:text-brand transition-colors">Pickup & Delivery</a></li>
              <li><a href="#about" className="hover:text-brand transition-colors">About Us</a></li>
              <li><a href="#contact" className="hover:text-brand transition-colors">Contact</a></li>
            </ul>
          </div>

        </div>
        
        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-400">
          <p>&copy; {new Date().getFullYear()} Central Cleaners & Bennett Valley Dry Cleaners. All rights reserved.</p>
          <p>Designed with care in Santa Rosa.</p>
        </div>
      </div>
    </footer>
  );
}
